import React, {useCallback, useState} from 'react';
import TitleImg from '../../images/prefecture-select__title.png'
import './AreaSelectPage.scss';
import {prefectures} from '../../models/Prefectures';
import OkButtonImg from "../../images/area-select__ok-button.png";
import OkButtonHoverImg from "../../images/area-select__ok-button--hover.png";
import {Store} from "../../models/Store";

type P = {
    onDone: (arg: string) => void;
};

export const PrefectureSelectPage = (props: P) => {

    window.scrollTo(0, 0);

    const name = prefectures[0][2];
    const [value, setValue] = useState(name[0].toUpperCase() + name.substring(1));

    const handleSubmit = useCallback(e => {
        e.preventDefault();

        // modelに保存
        Store.smileRegister.setPrefecture(value);

        // コールバック
        props.onDone(value);
    }, [props, value]);

    const handleChange = useCallback(e => {
        e.preventDefault();
        setValue(e.target.value);
    }, []);

    return (
        <div className='prefecture-select'>
            <h1 className='prefecture-select__title'><img src={TitleImg} width={1324 / 2} height={154 / 2} alt=""/></h1>

            <form onSubmit={handleSubmit}>

                <div className='area-select__select-container'>

                    <div className="area-select__select-wrapper">
                        <select className='area-select__select' value={value} onChange={handleChange}>
                            {
                                (() => {
                                    const list: any[] = [];
                                    for (let prefecture of prefectures) {
                                        const name = prefecture[2];
                                        const name2 = name[0].toUpperCase() + name.substring(1);
                                        list.push(<option key={name2} value={name2}>{name2}</option>);
                                    }
                                    return list;
                                })()
                            }
                        </select>
                    </div>
                </div>

                <div>
                    <div className='area-select__start-button-container'><input type='image' width={218} height={100}
                                                                                src={OkButtonImg}
                                                                                onMouseOver={e => e.currentTarget.src=OkButtonHoverImg}
                                                                                onMouseOut={e => e.currentTarget.src=OkButtonImg}
                                                                                style={{cursor: 'pointer'}} alt=""/>
                    </div>
                </div>
            </form>
        </div>
    );
};